import { html, View } from 'rune-ts';

export type ActionGuideMode =
  | 'IDLE'
  | 'HOLDING_DRAWN'
  | 'HOLDING_TAKEN'
  | 'POOL_PICK'
  | 'PLACEMENT_SELECTED'
  | 'INSERT_DRAG'
  | 'BONUS'
  | 'OPPONENT_TURN'
  | 'GAME_OVER'
  | 'NO_PLACEMENT';

export type ActionGuideData = {
  mode: ActionGuideMode;
  drawnNumber?: number;
  opponentNickname?: string;
};

export class ActionGuideView extends View<ActionGuideData> {
  override template() {
    const message = this.message();
    if (!message) {
      return html`<div class="action-guide hidden"></div>`;
    }
    return html`
      <div class="action-guide text-center text-body text-wood-coffee px-3 py-2 mlandscape:hidden">
        ${message}
      </div>
    `;
  }

  private message(): string {
    const { mode, drawnNumber } = this.data;
    switch (mode) {
      case 'IDLE':
        return '💡 더미에서 뽑거나 풀에서 가져오세요. 비공개 타일을 끌어 옮길 수도 있습니다';
      case 'HOLDING_DRAWN':
        return `${drawnNumber ?? ''} 획득. 노란 자리를 탭하세요`;
      case 'HOLDING_TAKEN':
        return `${drawnNumber ?? ''} 획득. 노란 자리를 탭하세요`;
      case 'POOL_PICK':
        return '풀에서 가져올 타일을 탭하세요. ✨ 표시는 내 줄에 놓을 수 있는 타일';
      case 'PLACEMENT_SELECTED':
        return '✓ 자리를 확정하거나 다른 자리를 탭해 변경';
      case 'INSERT_DRAG':
        return '⇲ 타일을 들어 다른 타일 사이에 끼워넣으세요';
      case 'BONUS':
        return '🔥 보너스 차례. 한 번 더 행동하세요';
      case 'OPPONENT_TURN':
        return '';
      case 'NO_PLACEMENT':
        return '놓을 곳이 없습니다. 자동으로 풀로 보냅니다…';
      case 'GAME_OVER':
        return '🏆 게임 종료';
      default:
        return '';
    }
  }
}
